import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
@NgModule({
	declarations: [],
	imports: [
		BrowserModule,
		HttpClientModule
	],
	providers: [
		DatePipe
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('Core Module already loadead. Import in the AppModule only.');
		}
	}
}
